module.exports = __webpack_public_path__ + "assets/img/e5d7-es-ct.svg";